import React from 'react';

import {
  AppBar,
  Box,
  Container,
  Link,
  Stack,
  styled,
  Toolbar
} from '@mui/material';
import {
  imageUtil,
  ResponsiveImage,
  routeDirectory,
  UserAccountButton
} from 'modules';



const imgsLogoDark = imageUtil.getUrlSet('logo', 'png');
const imgsLogoLight = imageUtil.getUrlSet('logo_light', 'png');



const StyledAppBar = styled(AppBar)({
});

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: theme.spacing(14)
}));

const StyledLink = styled(Link)({
  textTransform: 'uppercase',
  fontSize: 12,
  letterSpacing: '0.75px',
  opacity: 0.6
});

const LogoBox = styled(Box)({
  paddingBottom: 4
});

const LinkStack = styled(Stack)({
});



export interface IProps {
  layoutVariant?: 'superAdmin';
  colorVariant?: 'dark' | 'light';
}

export const FC: React.FC<IProps> = props => {
  const generateStyledLink = React.useCallback((text: string, href: string) => {
    const color = props.colorVariant === 'dark' ? '#FFFFFF' : '#486C82';

    return (
      <StyledLink
        style={{ color }}
        href={href}>
        {text}
      </StyledLink>
    );
  }, [props]);



  return (
    <StyledAppBar
      position="static"
      elevation={0}
      color="transparent">
      <Container>
        <StyledToolbar disableGutters>
          <LogoBox>
            <Link href={routeDirectory.home.path()}>
              <ResponsiveImage.FC urlSet={props.colorVariant === 'dark' ? imgsLogoLight : imgsLogoDark} />
            </Link>
          </LogoBox>

          {props.layoutVariant !== 'superAdmin' && (
            <LinkStack
              spacing={6}
              direction="row">
              {generateStyledLink('Pitch Deck', routeDirectory.pitchDecks.path())}
              {generateStyledLink('Investor Search',routeDirectory.investors.path())}
              {generateStyledLink('My Fundraises', routeDirectory.myFundraises.path())}
              {generateStyledLink('Legal', routeDirectory.legal.path())}
              {/* {generateStyledLink('Before + After', routeDirectory.beforeAndAfter.path())} */}
            </LinkStack>
          )}

          <Box>
            <UserAccountButton.FC colorVariant={props.colorVariant} />
          </Box>
        </StyledToolbar>
      </Container>
    </StyledAppBar>
  );
};
